import { createContext, useContext, useMemo, useState } from "react"

export const contextsTarjeta = createContext()

export function TarjetaProvider({ curso, showColaborador, children }) {
	const [openDialog, setOpenDialog] = useState(false)
	const [newStatus, setNewStatus] = useState(null)
	const [reload, setReload] = useState(false)
	const [pdf, setPdf] = useState(false)
	const datos = useMemo(
		() => ({
			curso,
			openDialog,
			setOpenDialog,
			newStatus,
			setNewStatus,
			reload,
			reloadNow: () => setReload(!reload),
			pdf,
			setPdf,
			showColaborador,
		}),
		[curso, newStatus, openDialog, pdf, reload, showColaborador]
	)

	return <contextsTarjeta.Provider value={datos}>{children}</contextsTarjeta.Provider>
}
/**
 * Hook personalizado que proporciona acceso al contexto del fondo.
 * @typedef {Object}  paramsContext Control de plan anual
 * @property {array} curso información de curso.
 * @property {boolean} openDialog Dialog de acciones.
 * @property {function} setOpenDialog Función para abrir o cerrar el dialog.
 * @property {function} reloadNow Función para recargar el componente.
 *
 */

/**
 *
 * @returns {paramsContext} .
 */
export function UseTarjetaContext() {
	return useContext(contextsTarjeta)
}

export const contextsTarjetaPdf = createContext()

export function TarjetaPdfProvider({ children }) {
	const [cursoId, setCursoId] = useState(false)
	const [pdf, setPdf] = useState(false)
	const datos = useMemo(
		() => ({
			pdf,
			setPdf,
			cursoId,
			setCursoId,
		}),
		[cursoId, pdf]
	)

	return (
		<contextsTarjetaPdf.Provider value={datos}>
			{children}
		</contextsTarjetaPdf.Provider>
	)
}

export function UseTarjetaPdfContext() {
	return useContext(contextsTarjetaPdf)
}
